import type {
  ISite,
  ISiteSystem,
  ISiteSystemEquipment,
  ISiteSystemPayload,
  ISiteSystemType,
} from '@/Core.Service.Domain/Sites/SiteSystems/types/index.ts';

const apiVersion = 'v1';

const getSiteSystems = async (siteId: number): Promise<ISiteSystem[]> => {
  try {
    const result = await window.axios.get(
      `/${apiVersion}/site-systems/sites/${siteId}`
    );
    const { data } = result.data;
    return data as ISiteSystem[];
  } catch (err) {
    return Promise.reject(err);
  }
};

const getSiteSystem = async (id: number): Promise<ISiteSystem> => {
  try {
    const result = await window.axios.get(`/${apiVersion}/site-systems/${id}`);
    const { data } = result.data;
    return data as ISiteSystem;
  } catch (err) {
    return Promise.reject(err);
  }
};

const getSiteSystemTypes = async (): Promise<ISiteSystemType[]> => {
  try {
    const result = await window.axios.get(`/${apiVersion}/site-systems/types`);
    const { data } = result.data;
    return data as ISiteSystemType[];
  } catch (err) {
    return Promise.reject(err);
  }
};

const createSiteSystem = async (
  siteId: number,
  payload: ISiteSystemPayload
): Promise<ISiteSystem> => {
  try {
    const result = await window.axios.post(
      `/${apiVersion}/site-systems/sites/${siteId}`,
      payload
    );
    const { data } = result.data;
    return data as ISiteSystem;
  } catch (err) {
    return Promise.reject(err);
  }
};

const updateSiteSystem = async (
  id: number,
  payload: ISiteSystemPayload
): Promise<ISiteSystem> => {
  try {
    const result = await window.axios.put(
      `/${apiVersion}/site-systems/${id}`,
      payload
    );
    const { data } = result.data;
    return data as ISiteSystem;
  } catch (err) {
    return Promise.reject(err);
  }
};

const deleteSiteSystem = async (id: number): Promise<void> => {
  try {
    await window.axios.delete(`/${apiVersion}/site-systems/${id}`);
  } catch (err) {
    return Promise.reject(err);
  }
};

const getEquipmentForSite = async (
  siteId: number
): Promise<ISiteSystemEquipment[]> => {
  try {
    const result = await window.axios.get(
      `/${apiVersion}/equipments/sites/${siteId}`
    );
    const { data } = result.data;
    return data as ISiteSystemEquipment[];
  } catch (err) {
    return Promise.reject(err);
  }
};

const getSitesPortfolio = async (): Promise<ISite[]> => {
  try {
    const result = await window.axios.get(`/${apiVersion}/sites/portfolio`);
    const { data } = result.data;
    return data as ISite[];
  } catch (err) {
    return Promise.reject(err);
  }
};

export default {
  getSiteSystems,
  getSiteSystem,
  getSiteSystemTypes,
  createSiteSystem,
  updateSiteSystem,
  deleteSiteSystem,
  getSitesPortfolio,
  getEquipmentForSite,
};
